var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_c('message-transition',_vm._l((_vm.messages),function(message,index){return _c('div',{key:index,staticClass:"message-item"},[_c('message',{attrs:{"message":message},on:{"close":_vm.handleClose}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }